//@ts-check

/**
 * @type {import("./types").getHumanFileSizeType}
 */
export default (function (bytes) {
  var thresh = 1024;
  if (bytes < thresh) return bytes + ' B';
  var units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var u = -1;

  do {
    bytes /= thresh;
    ++u;
  } while (bytes >= thresh);

  return bytes.toFixed(1) + ' ' + units[u];
});